module.exports = __webpack_public_path__ + "static/media/thaitvonline.c0cca133.png";